import React from 'react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  backTo?: string;
  backLabel?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  backTo = '/',
  backLabel = 'Back to Privacy Center',
}) => {
  return (
    <div className="mb-6">
      <Link
        to={backTo}
        className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-primary transition-colors mb-3"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
        {backLabel}
      </Link>
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
    </div>
  );
};
